export const black = "#000000";
export const white = "#ffffff";
export const bada55 = "#bada55";
export const loadingColors = {
  green: "#97bf0d",
  yellow: "#f8b334",
  teal: "#00a096",
};
export const tempColors = {
  blueLite: "#07f",
  blueDark: "#223254",
  grayDark: "#9098a9",
  grayLite: "#c8ccd4",
  grayAlt: "#5a667f",
};
export const gray = {
  "100": "#f5f5f5",
  "200": "#eeeeee", // x34
  "300": "#d3d3d3", // x 3
  "400": "#9e9e9e", // x 5
  "500": "#747474", // x11
  "600": "#616161", // x 3
  "700": "#424242", // x 19
  "800": "#242424", // x 13
  "900": "#131313",
};

export const common = {
  black,
  white,
};

export const red = {
  "100": "#a02727", // x 8
  "200": "#cc0000", // x 2
  "300": "#cf3a3a", // x 3
  "400": "#ee5050", // x 13
  "500": "#ff0000", // x5
  "600": "#e41919",
};

const colors = {
  gray,
  common,
  red,
};

export default colors;
